@if (!mobile) {
  <mat-sidenav-container class="main-container" autosize>
    <mat-sidenav class="main-sidenav" mode="side" opened>
      <mat-nav-list>
        @for (item of mainMenu; track item) {
          @if (item.link) {
            <mat-list-item class="main-list-item" role="listitem" [routerLink]="[item.link]">
              @if (item.icon) {
                <mat-icon matTooltipPosition="right" [matTooltip]="item.tooltip" class="main-menu-item noselect">{{
                  item.icon
                }}</mat-icon>
              }
            </mat-list-item>
          }
          @if (!item.link) {
            <mat-list-item class="main-list-item" role="listitem" (click)="open(item.click)">
              @if (item.icon) {
                <mat-icon matTooltipPosition="right" [matTooltip]="item.tooltip" class="main-menu-item noselect">{{
                  item.icon
                }}</mat-icon>
              }
            </mat-list-item>
          }
        }
      </mat-nav-list>
      <div class="vertical-fill"></div>
      <div class="institute-logo-wrapper">
        @if (instituteUrl) {
          <img class="institute-logo" defaultImage="/assets/images/loader1.gif" [src]="instituteUrl" alt="" />
        }
      </div>
      <mat-nav-list>
        @for (item of secondMenu; track item) {
          @if (item.link) {
            <mat-list-item class="main-list-item" role="listitem" [routerLink]="[item.link]">
              @if (item.icon) {
                <mat-icon matTooltipPosition="right" [matTooltip]="item.tooltip" class="main-menu-item noselect">{{
                  item.icon
                }}</mat-icon>
              }
            </mat-list-item>
          }
          @if (item.click) {
            <mat-list-item class="main-list-item" role="listitem" (click)="open(item.click)">
              @if (item.icon) {
                <mat-icon matTooltipPosition="right" [matTooltip]="item.tooltip" class="main-menu-item noselect">{{
                  item.icon
                }}</mat-icon>
              }
            </mat-list-item>
          }
        }
      </mat-nav-list>
    </mat-sidenav>
    <div class="main-sidenav-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-container>
}
@if (mobile) {
  <mat-toolbar color="primary">
    @for (item of mainMenu; track item) {
      @if (item.link) {
        <button
          class="noselect"
          matTooltipPosition="below"
          [matTooltip]="item.tooltip"
          [routerLink]="[item.link]"
          mat-icon-button>
          <mat-icon>{{ item.icon }}</mat-icon>
        </button>
      }
      @if (!item.link) {
        <button
          class="noselect"
          matTooltipPosition="below"
          [matTooltip]="item.tooltip"
          (click)="open(item.click)"
          mat-icon-button>
          <mat-icon>{{ item.icon }}</mat-icon>
        </button>
      }
    }
    <span class="horizontal-fill"></span>
    <div class="institute-logo-wrapper">
      @if (instituteUrl) {
        <img
          class="institute-logo institute-logo-mobile"
          defaultImage="/assets/images/loader1.gif"
          [lazyLoad]="instituteUrl | authImage | async" />
      }
    </div>
    @for (item of secondMenu; track item) {
      @if (item.link) {
        <button
          class="noselect"
          matTooltipPosition="below"
          [matTooltip]="item.tooltip"
          [routerLink]="[item.link]"
          mat-icon-button>
          <mat-icon>{{ item.icon }}</mat-icon>
        </button>
      }
      @if (item.click) {
        <button
          class="noselect"
          matTooltipPosition="below"
          [matTooltip]="item.tooltip"
          (click)="open(item.click)"
          mat-icon-button>
          <mat-icon>{{ item.icon }}</mat-icon>
        </button>
      }
    }
  </mat-toolbar>
  <router-outlet></router-outlet>
}
<app-case-drawer #caseDrawerComponent></app-case-drawer>
<app-information-drawer #informationDrawerComponent></app-information-drawer>
@if (this.showNotification && this.notificationToThrow.visible) {
  <app-notification-card
    [titleText]="notificationToThrow.title"
    [descriptionText]="notificationToThrow.description"
    (onCancelClick)="handleCancelBtn()"
    (onOkClick)="handleOkBtn()"
    [cancelButtonText]="notificationToThrow.cancelBtnText"
    [okButtonText]="notificationToThrow.okBtnText">
  </app-notification-card>
}
